import PropTypes from 'prop-types';
import React from 'react'
import MenuIcon from './MenuIcon';
import MenuItems from './MenuItems'


class NavBar extends React.PureComponent{
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false
        }
    }

    handleMenuClick = () => {
        this.setState({
            isOpen: true
        })
    }

    handleMenuClose = () => {
        this.setState({
            isOpen: false
        })
    }

    selectionHandler = (e) => {
        let item_id = e.target.getAttribute('name')
        item_id && this.props.setActiveItem(item_id)
        this.setState({
            isOpen: false
        })
    }

    render(){
        const {isOpen} = this.state
        const {items} = this.props
        return (
            <React.Fragment>
                {!isOpen && <MenuIcon clickHandler={this.handleMenuClick}/>}
                {isOpen && <MenuItems items={items}
                    closeHandler={this.handleMenuClose}
                    selectionHandler={this.selectionHandler}/>}
            </React.Fragment>
        )
    }
}

NavBar.propTypes = {
    setActiveItem: PropTypes.func,
    items: PropTypes.array
}

export default NavBar